import { useSelector } from "react-redux";
import {
  Container,
  Grid,
  Box,
  Typography
} from "@mui/material";

import Input from "@/components/ph/Input";
import Select from "@/components/ph/Select";

import { generateDays, generateMonths, generateYears } from "../../contractor/hooks/DateHelpers"

import FormSection from "../../utils/FormSection";

import { useFieldValidation } from "../hooks/useFieldValidation";

const DriverPersonalData = () => {

    const formValues = useSelector((state) => state.driver.formValues);

    const parseDateFromString = (dateString) => {
        if (!dateString || dateString.length !== 8) return { day: '', month: '', year: '' };

        try {
            const year = dateString.substring(0, 4);
            const month = String(Number(dateString.substring(4, 6)));
            const day = String(Number(dateString.substring(6, 8)));
            return { day, month, year };
        } catch (error) {
            return { day: '', month: '', year: '' };
        }
    };

    const { day: storedDay, month: storedMonth, year: storedYear } = parseDateFromString(formValues.fechaNacimiento);

    const nombresField = useFieldValidation("nombres", {
        requiredMessage: "El nombre es requerido",
        validate: (nombres) => {
            const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]+$/;
            if (!regex.test(nombres)) return "El Nombre solo puede contener letras y espacios";
            if (nombres.trim().length < 3) return "Debe tener al menos 3 caracteres";
            return "";
        },
        onKeyDown: (e) => {
            const allowedKeys = [
                "Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End", "Enter", " "
            ];
            if (allowedKeys.includes(e.key)) return;
            if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s']$/.test(e.key)) e.preventDefault();
        },
    });

    const primerApellidoField = useFieldValidation("primerApellido", {
        requiredMessage: "El Primer Apellido es requerido",
        validate: (nombres) => {
            const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]+$/;
            if (!regex.test(nombres)) return "El Primer Apellido solo puede contener letras y espacios";
            if (nombres.trim().length < 3) return "Debe tener al menos 3 caracteres";
            return "";
            },
        onKeyDown: (e) => {
            const allowedKeys = [
                "Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End", "Enter", " "
            ];
            if (allowedKeys.includes(e.key)) return;
            if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s']$/.test(e.key)) e.preventDefault();
        },
    });

    const segundoApellidoField = useFieldValidation("segundoApellido", {
        requiredMessage: "El Segundo Apellido es requerido",
        validate: (nombres) => {
            const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]+$/;
            if (!regex.test(nombres)) return "El Segundo Apellido solo puede contener letras y espacios";
            if (nombres.trim().length < 3) return "Debe tener al menos 3 caracteres";
            return "";
            },
        onKeyDown: (e) => {
            const allowedKeys = [
                "Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End", "Enter", " "
            ];
            if (allowedKeys.includes(e.key)) return;
            if (!/^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s']$/.test(e.key)) e.preventDefault();
        },
    });

    return (
        <Container maxWidth="md" disableGutters={{ xs: true, md: false }}>
            <FormSection>
                <Grid container spacing={2} size={{ xs: 12, md: 12 }}>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <Typography
                        variant="body1"
                        sx={{
                            color: "text.secondary",
                            mt: 1,
                            mb: 1,
                            fontSize: "1rem",
                            fontWeight: "500",
                        }}
                        >
                            DATOS PERSONALES DEL CONDUCTOR HABITUAL
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <Box
                        sx={{
                            minHeight: "3.5rem",
                            display: "flex",
                            alignItems: "flex-end",
                        }}
                        >
                        <Input
                            errorMessage="El nombre es un campo  requerido"
                            isInvalid={nombresField.isInvalid}
                            label="Nombres"
                            name="nombres"
                            value={nombresField.value || ""}
                            onChange={nombresField.handlers.onChange}
                            onBlur={nombresField.handlers.onBlur}
                            required
                            type="text"
                        />
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Box
                                sx={{
                                    minHeight: "3.5rem",
                                    display: "flex",
                                    alignItems: "flex-end",
                                }}
                                >
                                <Input
                                    errorMessage={primerApellidoField.getErrorMessage()}
                                    isInvalid={primerApellidoField.isInvalid}
                                    label="Primer Apellido"
                                    name="primerApellido"
                                    value={primerApellidoField.value}
                                    onChange={primerApellidoField.handlers.onChange}
                                    onBlur={primerApellidoField.handlers.onBlur}
                                    required
                                    type="text"
                                />
                                </Box>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Box
                                sx={{
                                    minHeight: "3.5rem",
                                    display: "flex",
                                    alignItems: "flex-end",
                                }}
                                >
                                <Input
                                    errorMessage={segundoApellidoField.getErrorMessage()}
                                    isInvalid={segundoApellidoField.isInvalid}
                                    name="segundoApellido"
                                    label="Segundo Apellido"
                                    value={segundoApellidoField.value}
                                    onChange={segundoApellidoField.handlers.onChange}
                                    onBlur={segundoApellidoField.handlers.onBlur}
                                    required
                                    type="text"
                                />
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={{ xs: 12 }}>
                        <Typography variant="body1" sx={{ color: "text.secondary", fontSize: ".8rem" }}>
                        Fecha de Nacimiento
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 12 }}>
                        <Grid container spacing={2} alignItems="flex-end">
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Grid container spacing={1} className="fecha-selects">
                                    <Grid size={{ xs: 3 }}>
                                        <Box
                                        sx={{
                                            minHeight: "3.5rem",
                                            display: "flex",
                                            alignItems: "flex-end",
                                        }}
                                        >
                                        <Select
                                            type="labeled"
                                            label="Día"
                                            name="dia"
                                            value={storedDay}
                                            options={generateDays()}
                                            disabled
                                            required
                                        />
                                        </Box>
                                    </Grid>
                                    <Grid size={{ xs: 5 }}>
                                        <Box
                                        sx={{
                                            minHeight: "3.5rem",
                                            display: "flex",
                                            alignItems: "flex-end",
                                        }}
                                        >
                                        <Select
                                            type="labeled"
                                            label="Mes"
                                            name="mes"
                                            value={storedMonth}
                                            options={generateMonths()}
                                            disabled
                                            required
                                        />
                                        </Box>
                                    </Grid>
                                    <Grid size={{ xs: 4 }}>
                                        <Box
                                        sx={{
                                            minHeight: "3.5rem",
                                            display: "flex",
                                            alignItems: "flex-end",
                                        }}
                                        >
                                        <Select
                                            type="labeled"
                                            label="Año"
                                            name="anio"
                                            value={storedYear}
                                            options={generateYears()}
                                            disabled
                                            required
                                        />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                                <Grid container>
                                    <Grid size={{ xs: 12 }}>
                                        <Box
                                        sx={{
                                            minHeight: "3.5rem",
                                            display: "flex",
                                            alignItems: "flex-end",
                                        }}
                                        >
                                        <Select
                                            type="labeled"
                                            label="Género"
                                            name="genero"
                                            value={formValues.genero || ""}
                                            options={[
                                                { value: "M", label: "Masculino" },
                                                { value: "F", label: "Femenino" },
                                            ]}
                                            disabled
                                            required
                                        />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </FormSection>
        </Container>
    );
};

export default DriverPersonalData;
